import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
  output,
  InputSignal,
  OutputEmitterRef,
} from '@angular/core';
import { KbModuleLinkPipe } from './kb-module-link.pipe';
import { RemoveWhitespacePipe } from './remove-whitespace.pipe';
import { CheckboxComponent } from '@lyceo/shared/ui-forms';

@Component({
  selector: 'lyceo-paragraph-theory',
  templateUrl: './paragraph-theory.component.html',
  styleUrls: ['./paragraph-theory.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [KbModuleLinkPipe, RemoveWhitespacePipe, CheckboxComponent],
  host: {
    class: 'lyceo-paragraph-theory',
  },
})
export class ParagraphTheoryComponent {
  public readonly theory: InputSignal<string> = input.required<string>();
  public readonly readTheory: InputSignal<boolean> = input.required<boolean>();
  public readonly showCheckbox: InputSignal<boolean> =
    input.required<boolean>();
  public readonly setProgress: OutputEmitterRef<boolean> = output<boolean>();

  public setHasReadTheory(): void {
    this.setProgress.emit(!this.readTheory());
  }
}
